class Slider {
  constructor() {
    this.attr = "data-slider";

    this.init();
  }

  init() {
    const eventsInit = ["product-grid-updated", "modal-open-slider-updated"];
    const eventsUpdate = ["product-card-color-swatches-loaded"];

    this.initSliderEvent();

    eventsInit.forEach((event) => {
      document.addEventListener(event, () => this.initSliderEvent());
    });

    eventsUpdate.forEach((event) => {
      document.addEventListener(event, () => this.updateSlider());
    });
  }

  initSliderEvent() {
    const sliders = document.querySelectorAll(`[${this.attr}]`);
    if (!sliders.length) return;

    sliders.forEach((slider) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(({ isIntersecting }) => {
            if (isIntersecting) {
              this.initSlider(slider);

              observer.unobserve(slider);
            }
          });
        },
        { rootMargin: "250px" },
      );

      observer.observe(slider);
    });
  }

  initSlider(slider) {
    if (!Swiper) return;

    const config = JSON.parse(slider.getAttribute(this.attr) || "{}");

    const instance = new Swiper(slider, config);
    const classes = { begin: "slider-beginning", end: "slider-end" };

    if (instance.isBeginning) slider.classList.add(classes.begin);

    instance.on("slideChange", () => {
      if (instance.isBeginning) {
        slider.classList.add(classes.begin);
      } else {
        slider.classList.remove(classes.begin);
      }

      if (instance.isEnd) {
        slider.classList.add(classes.end);
      } else {
        slider.classList.remove(classes.end);
      }
    });

    slider.swiperInstance = instance;
  }

  updateSlider() {
    const sliders = document.querySelectorAll(`[${this.attr}]`);
    sliders.forEach((slider) => {
      const instance = slider.swiperInstance;

      if (instance) {
        instance.update();
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => new Slider());
